import { ITableService } from 'src/app/common/interfaces/table/table-service.interface';
import {
  ICamt035AcwpOption,
  ICamt035AcwpUpdateRequest,
} from '../../interfaces/camt035/camt035-acwp.interface';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';

export abstract class AbstractRtpTransactionService extends ITableService {
  abstract getById(messageId: string, type: string): Promise<any>;
  abstract getReturnById(messageId: string, type: string): Promise<any>;
  abstract getAcwpOptions(): Promise<ICamt035AcwpOption[] | undefined>;
  abstract updateAcwpStatus(
    paymentInstructionId: string,
    request: ICamt035AcwpUpdateRequest
  ): Promise<IWebMessage | undefined>;
}
